// app/javascript/controllers/tinymce_controller.js
import { Controller } from "@hotwired/stimulus"
import tinymce from "tinymce"

import "tinymce/icons/default"
import "tinymce/themes/silver"
import "tinymce/models/dom"

import "tinymce/plugins/link"
import "tinymce/plugins/lists"
import "tinymce/plugins/code"
import "../vendor/tinymce/langs/it"

console.log("TINYMCE FILE LOADED")

export default class extends Controller {
  static targets = ["input"]

  connect() {
    console.log("🟢 TinyMCE controller CONNECT", this.element)

    if (!this.hasInputTarget) {
      console.error("❌ TinyMCE input target NOT FOUND")
      return
    }

    console.log("✅ target trovato:", this.inputTarget)
    
    tinymce.init({
      target: this.inputTarget,
      license_key: "gpl",
      language: "it",
      language_url: "/javascript/vendor/tinymce/langs/it.js",
      skin_url: '/assets/tinymce/skins/ui/oxide',
      content_css: '/assets/tinymce/skins/content/default',
      menubar: "format", // solo menu Formato
      branding: false,
      plugins: "link lists code",
      toolbar: "undo redo | styleselect | bold italic underline | bullist numlist | link | code",
      height: 300,
      setup: (editor) => {
        editor.on("init", () => {
          console.log("✅ TinyMCE READY")
        })
      }
    })
  }

  disconnect() {
    console.log("🔴 TinyMCE controller DISCONNECT")

    tinymce.remove(this.inputTarget)
  }
}
